import type { ReactNode } from 'react';
import * as yup from 'yup';

import type { DynamicComponent } from '../../dynamicComponent';
import type { CellComponent, DefinitionComponent, SectionComponent } from '../../types';

import { CardSection } from './card';

export const createSectionStrategy = (
  renderComponent: (definition: CellComponent) => ReactNode
) => {
  return {
    Component: (definition: DefinitionComponent) => {
      const def = definition as SectionComponent;
      return <CardSection def={def} renderComponent={renderComponent} />;
    },
    CanGet: (type: string) => {
      return type === 'section';
    },
    Validations: () => {
      return yup.object().shape({});
    }
  } as DynamicComponent;
};
